export default "__VITE_ASSET__CQyNPTVx__"